"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SqliteDataMigration", {
    enumerable: true,
    get: function() {
        return SqliteDataMigration;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _utils = require("~/utils");
const _formulaQueryBuilderv2 = /*#__PURE__*/ _interop_require_default(require("~/db/formulav2/formulaQueryBuilderv2"));
const _datamigrationhelper = require("~/services/formula-column-type-changer/data-migration.helper");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SqliteDataMigration = class SqliteDataMigration {
    async migrate({ baseModelSqlV2, formulaColumn, destinationColumn, formulaColumnOption, offset, limit }) {
        const knex = baseModelSqlV2.dbDriver;
        const formulaColumnAlias = '__nc_formula_value';
        const idOffsetTableAlias = 'id_offset_tbl';
        const formulaValueTableAlias = 'formula_value_tbl';
        const idOffsetTable = (0, _datamigrationhelper.getIdOffsetTable)({
            baseModelSqlV2,
            alias: idOffsetTableAlias,
            limit,
            offset
        }).whereRaw(Object.keys((0, _datamigrationhelper.getPrimaryKeySelectColumns)({
            model: baseModelSqlV2.model
        })).map(()=>'?? = ??').join(' and '), Object.keys((0, _datamigrationhelper.getPrimaryKeySelectColumns)({
            model: baseModelSqlV2.model
        })).reduce((arr, primaryColName)=>{
            arr.push(`${_utils.ROOT_ALIAS}.${primaryColName}`);
            arr.push(`${idOffsetTableAlias}.${primaryColName}`);
            return arr;
        }, []));
        const formulaValueTable = knex(baseModelSqlV2.getTnPath(baseModelSqlV2.model.table_name, formulaValueTableAlias)).select({
            [formulaColumnAlias]: (await (0, _formulaQueryBuilderv2.default)({
                baseModel: baseModelSqlV2,
                tree: formulaColumnOption.formula_raw,
                model: baseModelSqlV2.model,
                column: formulaColumn,
                validateFormula: false,
                tableAlias: formulaValueTableAlias,
                parsedTree: formulaColumnOption.getParsedTree()
            })).builder
        }).whereRaw(Object.keys((0, _datamigrationhelper.getPrimaryKeySelectColumns)({
            model: baseModelSqlV2.model
        })).map(()=>'?? = ??').join(' and '), Object.keys((0, _datamigrationhelper.getPrimaryKeySelectColumns)({
            model: baseModelSqlV2.model
        })).reduce((arr, primaryColName)=>{
            arr.push(`${_utils.ROOT_ALIAS}.${primaryColName}`);
            arr.push(`${formulaValueTableAlias}.${primaryColName}`);
            return arr;
        }, []));
        // knex qb is not yet support update select / update join
        // so we need to compose them manually (sad)
        const qb = knex.raw(`update ?? set ?? = (??) where exists (??)`, [
            baseModelSqlV2.getTnPath(baseModelSqlV2.model, _utils.ROOT_ALIAS),
            knex.raw(knex.ref(destinationColumn.column_name)),
            knex.raw(formulaValueTable),
            knex.raw(idOffsetTable)
        ]);
        await baseModelSqlV2.execAndParse(qb.toQuery(), null, {
            raw: true
        });
        return await (0, _datamigrationhelper.getUpdatedRows)({
            baseModelSqlV2,
            alias: idOffsetTableAlias,
            destinationColumn,
            limit,
            offset
        });
    }
    constructor(){
        this.dbDriverName = _nocodbsdk.ClientType.SQLITE;
    }
};
